import * as React from "react";

import { Table } from "simplydo/react/ui/table";

interface CalendarProps {
  /** Table content. */
  children: React.ReactNode;
  /** Whether to outline the calendar on focus. */
  outlineOnFocus: boolean;
  /** Picker width (any value that `style.width` can take). */
  pickerWidth?: string;
  /** Style object for picker. */
  pickerStyle?: object;
  /** Ref to the table element. */
  ref?: React.Ref<HTMLTableElement>;
}

function Calendar({
  children,
  outlineOnFocus,
  pickerWidth = "100%",
  pickerStyle,
  ref,
}: CalendarProps) {
  const style = {
    width: pickerWidth,
    minWidth: "22em",
    // Prevent poped up picker from beeing outlined on focus.
    // Inline picker should be outlined when in focus.
    outline: outlineOnFocus ? undefined : "none",
    ...pickerStyle,
  };

  return (
    <Table style={style} unstackable celled ref={ref} textAlign="center">
      {children}
    </Table>
  );
}

export default Calendar;
